import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const PropertyManagement = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my property management business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps property management businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for property management businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most property management businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my property management business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like property management. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Property Management - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Property Management CRM", url: "/industries/property-management" }
  ];

  const industryData = {
    name: 'Property Management',
    title: 'Scale Your Portfolio & Reduce Owner Turnover',
    subtitle: 'Automate tenant communications, streamline maintenance, and keep property owners happy long-term',
    icon: '🏘️',
    challenges: [
      'Property owners demand constant updates',
      'Maintenance requests create chaos',
      'Tenant turnover costs money',
      'Late rent payments hurt cash flow',
      'Hard to scale beyond 50 properties'
    ],
    solutions: [
      'Automated owner monthly reporting',
      'Maintenance ticketing system',
      'Tenant renewal automation',
      'Payment reminder sequences',
      'Scalable communication automation'
    ],
    features: [
      'Owner and tenant portals',
      'Maintenance request tracking',
      'Automated rent reminders',
      'Lease renewal automation',
      'Monthly owner reports',
      'Vendor coordination',
      'Inspection scheduling',
      'Online payment processing'
    ],
    results: [
      'Manage 3x more properties',
      '40% reduction in owner turnover',
      '95% on-time rent collection',
      '£8.3K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Property Management UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for property management businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for property management UK, property management business software, property management customer management, property management lead generation UK"
        url="/industries/property-management"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default PropertyManagement;